import { render, staticRenderFns } from "./SingleIndustry.vue?vue&type=template&id=4173ea54&scoped=true&"
import script from "./SingleIndustry.vue?vue&type=script&lang=js&"
export * from "./SingleIndustry.vue?vue&type=script&lang=js&"
import style0 from "./SingleIndustry.vue?vue&type=style&index=0&id=4173ea54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4173ea54",
  null
  
)

export default component.exports